<template>
  <div class="flex align-center flex-wrap">
    <el-select v-model="project" placeholder="请选择社区" class="margin-right-xs margin-bottom-sm" @change="fristChange"
               style="width: 150px;">
      <el-option
        v-for="item in projectList"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="community" placeholder="请选择小区" class="margin-right-xs margin-bottom-sm" @change="twoChange"
               style="width: 150px;">
      <el-option
        v-for="item in communityList"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="yuangong" placeholder="请选择志愿者队长" class="margin-right-xs margin-bottom-sm" v-if="halsYg"
               style="width: 150px;">
      <el-option
        v-for="item in yuangongList"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <el-select v-model="wancheng" placeholder="请选择报修类型" class="margin-right-xs margin-bottom-sm" v-if="halsYg"
               style="width: 150px;">
      <el-option
        v-for="item in wanchengList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="baoxiu" placeholder="请选择状态" class="margin-right-xs margin-bottom-sm" v-if="halsYg"
               style="width: 150px;">
      <el-option
        v-for="item in baoxiuList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-date-picker
      class="margin-right-xs margin-bottom-sm"
      v-model="dateArr"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="阶段变化开始日期"
      end-placeholder="阶段变化结束日期"
      :picker-options="pickerOptions">
    </el-date-picker>

    <el-button type="primary" class="margin-bottom-sm" @click="SearchInfo">搜索</el-button>
  </div>
</template>

<script>
import {getAdminByXiaoquId, getXiangMuList, getXiaoQuList} from "@/api/common";
import {baoxiuList, wanchengList} from "@/utils/utils";

export default {
  name: "static-chiose",
  props: {
    halsYg: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      projectList: [{id: 0, name: '全部社区'}],
      project: 0,
      communityList: [{id: 0, name: '全部小区'}],
      community: 0,
      yuangongList: [{id: 0, name: '全部志愿者队长'}],
      yuangong: 0,
      wanchengList: wanchengList,
      wancheng: 0,
      baoxiuList: baoxiuList,
      baoxiu: 0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      dateArr: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
        new Date()
      ]
    }
  },
  created() {
    this.SearchInfo()
    this.getXiangMuList()
  },
  components: {},
  methods: {
    /*
    * 获取社区列表
    * */
    async getXiangMuList() {
      let _data = await getXiangMuList()
      this.projectList = [...this.projectList, ..._data.data]
    },

    /*
   * 获取小区列表
   * */
    async getXiaoQuList(id) {
      let _data = await getXiaoQuList(id)
      this.communityList = [...this.communityList, ..._data.data]
    },
    fristChange(e) {
      this.communityList = [{id: 0, name: '全部小区'}]
      this.community = 0
      if (e) this.getXiaoQuList(e)
    },
    twoChange(e) {
      this.yuangongList = [{id: 0, name: '全部志愿者队长'}]
      this.yuangong = 0
      if (e) this.getYuangongList(e)
    },
    async getYuangongList(id) {
      let _data = await getAdminByXiaoquId(id)
      this.yuangongList = [...this.yuangongList, ..._data.data]
    },
    /*
    * 提交搜索数据
    * */
    SearchInfo() {
      this.$emit('SearchInfo', {
        project: this.project,
        community: this.community,
        yuangong: this.yuangong,
        wancheng: this.wancheng,
        baoxiu: this.baoxiu,
        dateArr: this.dateArr
      })
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
